import Modal from "components/Models/index";
import React, { useEffect, useState } from "react";
import "./editRole.scss";
import Drawer from "components/Drawer/index";
import EditRoleOperations from "./editRoleOperations/index";
import Button from "components/Button/index";
import useScreenMobile from "hooks/useScreen";

const EditRoleContent = ({
  onUpdateRole,
  handleCancel,
  role,
  availableTeams
}) => {
  const [roleData, setRoleData] = useState({
    roles: role?.roles || "",
    operations: role?.operations || []
  });

  // Update selected operations
  const updateOperations = (operations) => {
    
    setRoleData((prev) => ({ ...prev, operations }));
  };
  // Handle form submission
  const handleSubmit = () => {
    onUpdateRole(roleData);
    handleCancel();
  };

   useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault(); // prevent default Enter behavior
        handleSubmit();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [roleData]);
  return (
    <div className="EditRole">
      <div className="EditRoleTop">
       <h1>
          Edit&nbsp;Role&nbsp;&ndash;&nbsp;
          <span style={{ fontWeight: 700,  
                  color: "#9B2FAB",        
                  fontSize: "1.25rem",      
                  lineHeight: 1.2,   }}>{role?.roles ?? ""}
            </span>
        </h1>
        <p className="text">
          Please update the permission details.
        </p>
      </div>
      <div className="EditRoleWrapper">
        <div className="EditRoleContent">
          <EditRoleOperations team={role} updateOperations={updateOperations} />
        </div>
        <div className="EditRoleButtons">
          <Button
            type="violet"
            title="Update"
            width="100%"
            onClick={handleSubmit}
            diabled={roleData.operations.length === 0}
          />
        </div>
      </div>
    </div>
  );
};

function EditRole({ handleCancel, onUpdateRole, role, availableTeams }) {
  const isMobile = useScreenMobile({ size: 992 });
  return (
    <>
      {isMobile ? (
        <Drawer showFooter={false} handleCancel={handleCancel} isVisible={true}>
          <EditRoleContent
            onUpdateRole={onUpdateRole}
            handleCancel={handleCancel}
            role={role}
          />
        </Drawer>
      ) : (
        <Modal
          title="Edit Role"
          showFooter={false}
          showCross={true}
          handleCancel={handleCancel}
          padding="40px"
        >
          <EditRoleContent
            onUpdateRole={onUpdateRole}
            handleCancel={handleCancel}
            role={role}
          />
        </Modal>
      )}
    </>
  );
}

export default EditRole;
